import {
	useCallback,
	useContext
} from 'react';
import createDataContext from '../services/createDataContext';

import { getEventTags } from '../api/nora/calendar';

import calendarReducer, {
	SET_CALENDAR_EVENT,
	SET_CALENDAR_EVENTS,
	SET_EVENT_TAGS
} from '../reducers/calendarReducer';

export let controller = new AbortController();

const initialState = {
	calendarEvent: null,
	calendarEvents: [],
	eventTags: []
};

// init functions
const setEventTags = async dispatch => {
	try {
		const tags = await getEventTags();

		const mappedTags = tags.map( ( {
			id,
			text,
			color
		} ) => ( {
			key: id,
			text,
			value: id,
			color,
			icon: {
				style: { color },
				name: 'tags'
			}
		} ) );

		SET_EVENT_TAGS( dispatch, controller.signal )( mappedTags );
	} catch ( error ) {
		// handle
	}
};

const onInit = async dispatch => {
	controller = new AbortController();

	await setEventTags( dispatch );
};

const onCleanup = () => {
	controller.abort();
};

export const {
	StateContext,
	ActionContext,
	Provider
} = createDataContext( {
	reducer: calendarReducer,
	initialState,
	controller,
	onInit,
	onCleanup
} );

export function useCalendarState() {
	const state = useContext( StateContext );

	return state;
}

export function useCalendarAction() {
	const dispatch = useContext( ActionContext );

	const clearCalendarEvent = useCallback( () => {
		SET_CALENDAR_EVENT( dispatch, controller.signal )( null );
	}, [ dispatch ] );

	const setCalendarEvent = useCallback( data => {
		SET_CALENDAR_EVENT( dispatch, controller.signal )( data );
	}, [ dispatch ] );

	const setCalendarEvents = useCallback( data => {
		SET_CALENDAR_EVENTS( dispatch, controller.signal )( data );
	}, [ dispatch ] );

	return {
		clearCalendarEvent,
		setCalendarEvent,
		setCalendarEvents,
		setEventTags
	};
}
